import { render, staticRenderFns } from "./PDPDiscussionContent.vue?vue&type=template&id=549fde96&scoped=true&"
import script from "./PDPDiscussionContent.vue?vue&type=script&lang=js&"
export * from "./PDPDiscussionContent.vue?vue&type=script&lang=js&"
import style0 from "./PDPDiscussionContent.vue?vue&type=style&index=0&id=549fde96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549fde96",
  null
  
)

export default component.exports